/** Sent on enroll / resume / refresh so admin can see what clients run. */
export type ClientDeviceMeta = {
  app_version: string;
  build_number: string;
  platform: "web";
};

declare const __SUNDIUS_WEB_VERSION__: string | undefined;
declare const __SUNDIUS_WEB_BUILD__: string | undefined;

export function clientDeviceMeta(): ClientDeviceMeta {
  const version =
    typeof __SUNDIUS_WEB_VERSION__ === "string" && __SUNDIUS_WEB_VERSION__
      ? __SUNDIUS_WEB_VERSION__
      : "0.0.0";
  const build =
    typeof __SUNDIUS_WEB_BUILD__ === "string" && __SUNDIUS_WEB_BUILD__
      ? __SUNDIUS_WEB_BUILD__
      : "0";
  return {
    platform: "web",
    app_version: version,
    build_number: build,
  };
}
